import withScrollToTop from './with-scroll-to-top';

export default withScrollToTop;